import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './Security/auth.guard';
import { LoginComponent } from './Components/Usuario/login/login.component';
import { IndexComponent } from './Components/index/index/index.component';
import { ArticuloComponent } from './Components/articulo/articulo/articulo.component';
import { ClienteIndexComponent } from './Components/cliente/cliente-index/cliente-index.component';
import { PedidoIndexComponent } from './Components/pedido/pedido-index/pedido-index.component';
import { PrintPedidoComponent } from './Components/print/print-pedido/print-pedido.component';
import { ComprasComponent } from './Components/compras/compras.component';
import { AjusteComponent } from './Components/ajuste/ajuste.component';
import { FacturacionComponent } from './Components/facturacion/facturacion.component';
import { PrintBoletaComponent } from './Components/print/print-boleta/print-boleta.component';
import { PrintFacturaComponent } from './Components/print/print-factura/print-factura.component';
import { LiquidacionComponent } from './Components/liquidacion/liquidacion.component';
import { GastosComponent } from './Components/gastos/gastos.component';
import { IngresosComponent } from './Components/ingresos/ingresos.component';
import { SaldosComponent } from './Components/saldos/saldos.component';
import { PrintliquidacionComponent } from './Components/print/printliquidacion/printliquidacion.component';
import { PersonalComponent } from './Components/personal/personal.component';
import { PrintVentasaClientesComponent } from './Components/print/print-ventasa-clientes/print-ventasa-clientes.component';
import { PrintVentasPorVendedorComponent } from './Components/print/print-ventas-por-vendedor/print-ventas-por-vendedor.component';
import { PrintVentasPorClienteComponent } from './Components/print/print-ventas-por-cliente/print-ventas-por-cliente.component';
import { VentasPorMesYClientesComponent } from './Components/print/ventas-por-mes-yclientes/ventas-por-mes-yclientes.component';
import { SucursalComponent } from './Components/sucursal/sucursal.component';
import { PrintVentasPorZonasComponent } from './Components/print/print-ventas-por-zonas/print-ventas-por-zonas.component';
import { ZonasComponent } from './Components/zonas/zonas.component';
import { UbicacionComponent } from './Components/ubicacion/ubicacion.component';
import { ProveedorComponent } from './Components/proveedor/proveedor.component';
import { AfpEmpresaComponent } from './Components/Maestros/afp-empresa/afp-empresa.component';
import { BancosComponent } from './Components/Maestros/bancos/bancos.component';
import { CargoComponent } from './Components/Maestros/cargo/cargo.component';
import { ConceptpPlanillaComponent } from './Components/Maestros/conceptp-planilla/conceptp-planilla.component';
import { EstadoPeriodoComponent } from './Components/Maestros/estado-periodo/estado-periodo.component';
import { EstadoPlanillaComponent } from './Components/Maestros/estado-planilla/estado-planilla.component';
import { FormasDePagoComponent } from './Components/Maestros/formas-de-pago/formas-de-pago.component';
import { TipoContratoComponent } from './Components/Maestros/tipo-contrato/tipo-contrato.component';
import { PeriodoPagoComponent } from './Components/Maestros/periodo-pago/periodo-pago.component';
import { PlanillaMensualComponent } from './Components/Planilla/planilla-mensual/planilla-mensual.component';
const routes: Routes = [

  { path:'',component:PedidoIndexComponent,canActivate: [AuthGuard]  },
  { path:'ventas',component:PedidoIndexComponent,canActivate: [AuthGuard]  },
  { path:'articulo',component:ArticuloComponent,canActivate: [AuthGuard]  },
  { path:'usuario/login',component:LoginComponent},
  { path:'usuario/index',component:IndexComponent ,canActivate: [AuthGuard]},
  { path:'cliente',component:ClienteIndexComponent ,canActivate: [AuthGuard]},
  { path:'printer/boleta/:facturaId',component:PrintBoletaComponent },
  { path:'printer/factura/:facturaId',component:PrintFacturaComponent },
  { path:'printer/pedido/:facturaId',component:PrintPedidoComponent },
  { path:'printer/ventas/:mes',component:PrintVentasaClientesComponent,canActivate: [AuthGuard]},
  { path:'printer/ventasclientesporproducto/:idprod',component:VentasPorMesYClientesComponent,canActivate: [AuthGuard]},
  { path:'printer/ventas_clientes/:mes',component:PrintVentasPorClienteComponent,canActivate: [AuthGuard]},
  { path:'printer/ventas_vendedor/:mes/:idvende',component:PrintVentasPorVendedorComponent,canActivate: [AuthGuard]},
  { path:'printer/ventas_zona/:mes/:ubigeo',component:PrintVentasPorZonasComponent,canActivate: [AuthGuard]},
  { path:'compras',component:ComprasComponent,canActivate: [AuthGuard]  },
  { path:'ajuste',component:AjusteComponent,canActivate: [AuthGuard]  },
  { path:'facturacion',component:FacturacionComponent,canActivate: [AuthGuard]},
  { path:'liquidacion',component:LiquidacionComponent,canActivate: [AuthGuard]},
  { path:'gastos',component:GastosComponent,canActivate: [AuthGuard]},
  { path:'ingresos',component:IngresosComponent,canActivate: [AuthGuard]},
  { path:'saldos',component:SaldosComponent,canActivate: [AuthGuard]},
  { path:'printer/liquidacion/:liquidacionId',component:PrintliquidacionComponent,canActivate: [AuthGuard]},
  //{ path:'personal',component:PersonalComponent,canActivate: [AuthGuard]},
  //{ path:'zonas',component:ZonasComponent,canActivate: [AuthGuard]},
  //{ path:'ubicaciones',component:UbicacionComponent,canActivate: [AuthGuard]},
  //{ path:'sucursal',component:SucursalComponent,canActivate: [AuthGuard]},
  //{ path:'proveedor', component: ProveedorComponent, canActivate: [AuthGuard] },

  //Maestros
  { path:'maestros/personal',component:PersonalComponent,canActivate: [AuthGuard]},
  { path:'maestros/zonas',component:ZonasComponent,canActivate: [AuthGuard]},
  { path:'maestros/ubicaciones',component:UbicacionComponent,canActivate: [AuthGuard]},
  { path:'maestros/sucursal',component:SucursalComponent,canActivate: [AuthGuard]},
  { path:'maestros/proveedor',component:ProveedorComponent,canActivate: [AuthGuard]},
  { path:'maestros/afp-empresa', component: AfpEmpresaComponent, canActivate: [AuthGuard] },
  //bancos, cargo, conceptp-planilla, estado-perdiodo, formas-de-pago,tipo-contrato crea la ruta para cada uno
  { path: 'maestros/bancos', component: BancosComponent, canActivate: [AuthGuard] },
  { path: 'maestros/cargos', component: CargoComponent, canActivate: [AuthGuard] },
  { path: 'maestros/conceptos-planilla', component: ConceptpPlanillaComponent, canActivate: [AuthGuard] },
  { path: 'maestros/estado-periodo', component: EstadoPeriodoComponent, canActivate: [AuthGuard] },
  { path: 'maestros/estado-planilla', component: EstadoPlanillaComponent, canActivate: [AuthGuard] },
  { path: 'maestros/formas-de-pago', component: FormasDePagoComponent, canActivate: [AuthGuard] },
  { path: 'maestros/tipo-contrato', component: TipoContratoComponent, canActivate: [AuthGuard] },

  //Planilla
  { path: 'planilla/periodos', component: PeriodoPagoComponent, canActivate: [AuthGuard] },
  { path: 'planilla/planilla-mensual', component: PlanillaMensualComponent, canActivate: [AuthGuard] },



];

@NgModule({
  imports: [RouterModule.forRoot(routes,{onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})

export class AppRoutingModule { }
